import { AbstractControl, ValidationErrors } from '@angular/forms';
import { GenericAccountValidator } from './generic-account-validator';

export class BitcoinAddressAccountValidator extends GenericAccountValidator {
    protected static errors: any = {
        'es-AR': {
            bad_email:
                'Dirección incorrecta, debe ser por ejemplo: 3HBduv8byu6HEiHKUiJcr4qhTGc3FEpmht (BTC) o 0x8eF13B3D3cc05d79e3dd7B8C70286929C7f0d679 (BEP20)'
        },
        'en-US': {
            bad_email:
                'Incorrect adress, here`s an example: 3HBduv8byu6HEiHKUiJcr4qhTGc3FEpmht (BTC) or 0x8eF13B3D3cc05d79e3dd7B8C70286929C7f0d679 (BEP20)'
        }
    };
    protected static label: any = {
        'es-AR': 'Dirección',
        'en-US': 'Adress of'
    };
    protected static placeholder: any = {
        'es-AR': '3HBduv8byu6HEiHKUiJcr4qhTGc3FEpmht (BTC) o 0x8eF13B3D3cc05d79e3dd7B8C70286929C7f0d679 (BEP20)',
        'en-US': '3HBduv8byu6HEiHKUiJcr4qhTGc3FEpmht (BTC) o 0x8eF13B3D3cc05d79e3dd7B8C70286929C7f0d679 (BEP20)'
    };
    public getLabelToAccountType(): string {
        return 'Dirección BTC (Bitcoin) o BEP20 (BSC)';
    }

    public getPlaceholderToAccountType(): string {
        return (
            BitcoinAddressAccountValidator.placeholder[BitcoinAddressAccountValidator.lang] ??
            BitcoinAddressAccountValidator.placeholder['es-AR']
        );
    }

    public accountValidate(control: AbstractControl): ValidationErrors | null {
        let error: any =
            BitcoinAddressAccountValidator.errors[BitcoinAddressAccountValidator.lang] ?? BitcoinAddressAccountValidator.errors['es-AR'];
        if (/^([13][a-zA-HJ-NP-Z0-9]{32,33}|bc[a-zA-HJ-NP-Z0-9]{40})$/.test(control.value)) {
            return null;
        }
        if (/^0x[a-fA-F0-9]{40}$/.test(control.value)) {
            return null;
        }

        return { forbiddenName: error.bad_email };
    }
}
